import React from 'react';
import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import ChangeToneIcon from '@atlaskit/icon/core/microphone';
import { fg } from '@atlaskit/platform-feature-flags';
import { ToneCasualIcon } from '../../../../icons/prompt/toneCasual';
import { ToneEducationalIcon } from '../../../../icons/prompt/toneEducational';
import { ToneEmpatheticIcon } from '../../../../icons/prompt/toneEmpathetic';
import { ToneNeutralIcon } from '../../../../icons/prompt/toneNeutral';
import { ToneProfessionalIcon } from '../../../../icons/prompt/toneProfessional';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
function createChangeToneOption(_ref) {
  var key = _ref.key,
    title = _ref.title,
    description = _ref.description,
    intentSchemaId = _ref.intentSchemaId,
    icon = _ref.icon,
    shortTitle = _ref.shortTitle;
  return {
    key: key,
    title: title,
    description: description,
    icon: icon,
    showInRefineDropdown: true,
    intentSchemaId: intentSchemaId,
    nestingConfig: {
      id: 'change-tone-to',
      parentTestId: 'change-tone-to',
      parentTitle: aiConfigItemMessages.changeToneNestingParentTitlePostGA,
      shortTitle: shortTitle,
      icon: function icon() {
        return /*#__PURE__*/React.createElement(ChangeToneIcon, {
          label: "",
          spacing: "spacious"
        });
      }
    },
    actions: {
      empty: [createInsertBelow({
        appearance: 'secondary'
      }), createReplace({
        appearance: 'primary'
      })],
      selection: [createInsertBelow({
        appearance: 'secondary'
      }), createReplace({
        appearance: 'primary'
      })]
    },
    getBackendModel: function getBackendModel() {
      if (fg('platform_editor_ai_assistance_service') || fg('platform_editor_ai_assistance_service_second')) {
        return 'assistance-service';
      }
      return 'xp-gen-ai';
    }
  };
}
export var changeToneToNeutral = createChangeToneOption({
  key: CONFIG_ITEM_KEYS.CHANGE_TONE_TO_NEUTRAL,
  title: aiConfigItemMessages.changeToneNeutralToneTitle,
  shortTitle: aiConfigItemMessages.changeToneNeutralToneShortTitle,
  description: aiConfigItemMessages.changeToneNeutralToneDescription,
  intentSchemaId: 'change_tone_neutral_intent_schema.json',
  icon: function icon() {
    return /*#__PURE__*/React.createElement(ToneNeutralIcon, null);
  }
});
export var changeToneToNeutralWithOptions = {
  config: changeToneToNeutral,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};
export var changeToneToProfessional = createChangeToneOption({
  key: CONFIG_ITEM_KEYS.CHANGE_TONE_TO_PROFESSIONAL,
  title: aiConfigItemMessages.changeToneProfessionalToneTitle,
  shortTitle: aiConfigItemMessages.changeToneProfessionalToneShortTitle,
  description: aiConfigItemMessages.changeToneProfessionalToneDescription,
  intentSchemaId: 'change_tone_professional_intent_schema.json',
  icon: function icon() {
    return /*#__PURE__*/React.createElement(ToneProfessionalIcon, null);
  }
});
export var changeToneToProfessionalWithOptions = {
  config: changeToneToProfessional,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};
export var changeToneToCasual = createChangeToneOption({
  key: CONFIG_ITEM_KEYS.CHANGE_TONE_TO_CASUAL,
  title: aiConfigItemMessages.changeToneCasualToneTitle,
  shortTitle: aiConfigItemMessages.changeToneCasualToneShortTitle,
  description: aiConfigItemMessages.changeToneCasualToneDescription,
  intentSchemaId: 'change_tone_business_casual_intent_schema.json',
  icon: function icon() {
    return /*#__PURE__*/React.createElement(ToneCasualIcon, null);
  }
});
export var changeToneToCasualWithOptions = {
  config: changeToneToCasual,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};
export var changeToneToEducational = createChangeToneOption({
  key: CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EDUCATIONAL,
  title: aiConfigItemMessages.changeToneEducationalToneTitle,
  shortTitle: aiConfigItemMessages.changeToneEducationalToneShortTitle,
  description: aiConfigItemMessages.changeToneEducationalToneDescription,
  intentSchemaId: 'change_tone_educational_intent_schema.json',
  icon: function icon() {
    return /*#__PURE__*/React.createElement(ToneEducationalIcon, null);
  }
});
export var changeToneToEducationalWithOptions = {
  config: changeToneToEducational,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};
export var changeToneToEmpathetic = createChangeToneOption({
  key: CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EMPATHETIC,
  title: aiConfigItemMessages.changeToneEmpatheticToneTitle,
  shortTitle: aiConfigItemMessages.changeToneEmpatheticToneShortTitle,
  description: aiConfigItemMessages.changeToneEmpatheticToneDescription,
  intentSchemaId: 'change_tone_empathetic_intent_schema.json',
  icon: function icon() {
    return /*#__PURE__*/React.createElement(ToneEmpatheticIcon, null);
  }
});
export var changeToneToEmpatheticWithOptions = {
  config: changeToneToEmpathetic,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};